import {
  BroadcastByUserQuery,
  BroadcastManyQuery,
  EnumBroadcastStatus,
} from "gql/generated";

export const getBroadcastInError = (
  isPreview: boolean,
  displayDeletedErrorInPreview: boolean,
  broadcast?:
    | BroadcastManyQuery["broadcastMany"][0]
    | BroadcastByUserQuery["broadcastByUser"][0]
    | null,
) => {
  const isBroadcastDeleted = broadcast?.status === EnumBroadcastStatus.Deleted;
  const isBroadcastUnpublished =
    broadcast?.status === EnumBroadcastStatus.Draft;
  const isBroadcastNotSharedWithMe = !broadcast; // If a broadcast is not found, it is not shared with the user

  const isInError =
    isBroadcastDeleted || isBroadcastUnpublished || isBroadcastNotSharedWithMe;

  const displayError = isPreview
    ? displayDeletedErrorInPreview
      ? isInError
      : false
    : isInError;

  return {
    isBroadcastDeleted,
    isBroadcastUnpublished,
    isInError,
    displayError,
  };
};
